import { render, staticRenderFns } from "./FurnitureTransport.vue?vue&type=template&id=2a252a3e&scoped=true&"
import script from "./FurnitureTransport.vue?vue&type=script&lang=js&"
export * from "./FurnitureTransport.vue?vue&type=script&lang=js&"
import style0 from "./FurnitureTransport.vue?vue&type=style&index=0&id=2a252a3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a252a3e",
  null
  
)

export default component.exports